import { render, staticRenderFns } from "./BidCell.vue?vue&type=template&id=456f20f5&"
import script from "./BidCell.vue?vue&type=script&lang=js&"
export * from "./BidCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports